import { fn, IInfOperation } from '@common/utils';
import { NavPageItem } from '@common/navdata';
import { DialogService } from '../services/dialogservice';
import { IFDRW_Workflow_Start, Pages, RwfBootstrap, ValidateFileSize } from '@common/rwf';
import { CompatibilityService } from '@services/compatibilityservice';
import { AppVersion } from '@common/interfaces';

interface IFDRW_Workflow_StartEx extends IFDRW_Workflow_Start {
    _Caption?: string;

}
export type IFileContent = {
    /**  Name of the File (wOut Path, with Extension)*/
    Name: string;
    /** Item Exists */
    Exists?: () => boolean;
    /** Trigger Delete Operation of provided File */
    Delete?: () => void;
    /** Read Content of File */
    Base64Content: () => string | PromiseLike<string>;
};

export function CreateWorkflowModal($c: CompatibilityService, externalFile?: IFileContent) {
    const NavClientService = $c.resolve("NavClient");
    const DialogService = $c.resolve("DialogService");

    return DialogService.ShowWindow({
        windowOptions: {
            modal: true,
            resizable: true,
            title: "Workflow starten" + (externalFile && (" " + externalFile.Name) || "")
        },
        template: require("./createWorkflow.html"),
        controller: CreateWorkflowController,
        controllerAs: "vm",
        resolve: {
            "CreateItems": [() => {
                return NavClientService.LoadItemsSeperate<IFDRW_Workflow_Start>({
                    PageName: Pages.FDRW_Workflow_Start.PageName,
                    Constraints: [],
                    PageCount: 0
                }, NavClientService, true).then(items => {
                    if (!items || items.length == 0)
                        throw new Error("Neuen Workflow starten nicht möglich:\nEs wurden keine Schritte zum Start von Workflows konfiguriert oder Sie haben keinen Zugriff!");
                    return items;
                });
            }],
            "ExternalFile": [fn.ToFunc(externalFile)]
        }
    }).then((w) => {
        var controller = <CreateWorkflowController>w.controller;
        controller.dlgWindow = w.window;
        return w.close.then(fn.noop);
    });
}

export class CreateWorkflowController {
    public dlgWindow: kendo.ui.Window;
    static $inject = ["$scope", "RwfBootstrap", "DialogService", "CompatibilityService", "CreateItems", "InfomaAppVersion", "ExternalFile"];
    constructor(
        $scope: ng.IScope,
        RwfBootstrap: RwfBootstrap,
        DialogService: DialogService,
        $c: CompatibilityService,
        CreateItems: NavPageItem<IFDRW_Workflow_Start>[],
        InfomaAppVersion: AppVersion,
        public readonly ExternalFile?: IFileContent) {

        CreateItems = CreateItems || [];
        CreateItems.forEach(item => {
            var check = (item.Model as IFDRW_Workflow_StartEx);
            if (check && !check._Caption) {
                check._Caption = (check.WorkflowPartName || check.WFPartCode) + " > " + (check.WorkflowStepName || check.WFStepCode);
            }
        });
        this.SelectedCreateItem = (CreateItems.length == 1 && CreateItems[0].Model) || undefined;
        this.CreateItems = CreateItems.map(item => item.Model) || [];
        this.uploadOptions = <kendo.ui.UploadOptions>{
            enabled: true,
            multiple: false, //  multiple : problems, as technical key is used for upload and upload changes the key
            error: (e) => {
                DialogService.ShowError(e.XMLHttpRequest);
            },
            select: (e) => {
                var ext = e.files[0].extension || "";
                if (ext.toLowerCase() != ".pdf") {
                    e.preventDefault();
                    DialogService.ShowError("Nur PDF Dokumente können zum Start eines Workflows verwendet werden!");
                }
            },
            localization: {
                select: "Dokument (PDF) wählen..."
            }
        };
        this.CreateWorkflow = {
            Execute: () => {
                if (!this.fileUpload) {
                    throw new Error('fileUpload not found!');
                }
                var selItem = this.SelectedCreateItem;
                let createModel = fn.FindFirst(CreateItems, item => item.Model.Key === selItem.Key);

                let useFile = this.ExternalFile;
                if (!useFile) {
                    let file = <File><any>$("input[type=file]", this.fileUpload.wrapper).map((idx, element: HTMLInputElement) => element.files && element.files[0])[0];
                    if (file) {
                        ValidateFileSize(file);
                        useFile = ContentFromFile($c, file);
                    }
                }
                let getFileContent: PromiseLike<string>;
                if (useFile) {
                    if (useFile.Name) {
                        // check for exension
                        var p = useFile.Name.toLowerCase().split(".");
                        var ext = p.length > 1 ? p[p.length - 1] : undefined;
                        if (ext && ext !== "pdf") {
                            throw new Error("Nur Pdf- Dokumente können für die Neuanlage verwendet werden!");
                        }
                    }
                    getFileContent = $c.when(useFile.Base64Content());
                } else {
                    getFileContent = RwfBootstrap.Resolve.then(settings => {
                        if (!settings.RwfSetup.IsBWFActive)
                            return $c.reject("Ein Workflow kann nur mit Dokument gestartet werden.");
                        else
                            return DialogService.WhenConfirm("Workflow ohne Dokument starten?").then(fn.ToFunc(""));
                    });
                }

                var createResult = getFileContent.then(fileContent => 
                    $c.post("infoma.Web.KWF3/StartAndOpenNewWorkflow?" + 
                        fn.EncodeQueryData({ navUrl: createModel.ClientInfo.Url }), { 
                            fileContent : fileContent,
                            wFStart : selItem.Key
                        })
                ).then((response) => {
                    var newItemId = response.data["Result"];
                    // Delete File if applicable
                    if (useFile && typeof useFile.Delete === "function") {
                        $c.when().then(() => useFile.Delete()).then(undefined, err => DialogService.ShowError(err));
                    }
                    $c.resolve("Rwf")("RwfUserInteraction").EditWorkflowInstance($c, <any>kendo.observable({ ID: newItemId }), false);
                    if (this.dlgWindow) {
                        this.dlgWindow.close();
                    }
                }).then(fn.identity, err => DialogService.ShowError(err));
                if (this.dlgWindow) {
                    this.dlgWindow.element.kendoNavBusyIndicator(createResult);
                }
                return createResult;
            },
            Enabled: false
        };

        this.Cancel = {
            Enabled: !!this.ExternalFile,
            Execute: () => {
                var actClose = () => this.dlgWindow.close();
                return $c.when((typeof ExternalFile.Delete == "function") &&
                    (DialogService.ShowConfirm(`Dokument '${ExternalFile.Name}' löschen?`).then(doIt => {
                        if (doIt) {
                            this.ExternalFile.Delete();
                        }
                    }))
                ).then(actClose, actClose);
            }
        };
        $scope.$watch<IFDRW_Workflow_Start>(s => this.SelectedCreateItem, (newVal) => {
            this.CreateWorkflow.Enabled = !!(newVal && newVal.Key && newVal.WFStepCode);
        });
    }

    /** Create Workflow Operation Bond to ui */
    public CreateWorkflow: IInfOperation;

    public readonly Cancel: IInfOperation;

    /** Container Bound to UI */
    public CreateItems: IFDRW_Workflow_StartEx[];

    public SelectedCreateItem: IFDRW_Workflow_StartEx;

    public uploadOptions: kendo.ui.UploadOptions;

    /** attached from UI */
    public fileUpload: kendo.ui.Upload;
}

function ContentFromFile($c: CompatibilityService, file: File): IFileContent {
    return {
        Name: file.name,

        Base64Content: () => {
            let doGetFile = $c.defer<string>();
            try {
                var reader = new FileReader();
                reader.addEventListener("loadend", function () {
                    const result = this.result;
                    if (typeof result !== "string") {
                        doGetFile.reject('Unexpected result Type');
                    } else {
                        doGetFile.resolve(result.split(",")[1]);
                    }
                }, false);

                reader.addEventListener("error", () => {
                    doGetFile.reject(new Error("Failed to read file Content"));
                });

                reader.readAsDataURL(file);
            } catch (err) {
                doGetFile.reject(err);
            }
            return doGetFile.promise;
        }
    };
}
